// extracted by mini-css-extract-plugin
export default {"error":"ServiceForm_error__DJl3M","errorOutline":"ServiceForm_errorOutline__Rupvi","placeholder":"ServiceForm_placeholder__u3IR5","form":"ServiceForm_form__LefA9"};